<ng-template #alertHost></ng-template>
<a class="skip-link" href="#main-content">Skip to main content</a>
<!-- Header Area Start  -->


<div class="popup-backdrop" *ngIf="playerStatisticsSec">
    <div class="popup-card">
        <div class="popup-header">
            <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#ffff">
                <path
                    d="m296-320 122-122 80 80 142-141v63h80v-200H520v80h63l-85 85-80-80-178 179 56 56Zm-96 200q-33 0-56.5-23.5T120-200v-560q0-33 23.5-56.5T200-840h560q33 0 56.5 23.5T840-760v560q0 33-23.5 56.5T760-120H200Zm0-80h560v-560H200v560Zm0-560v560-560Z" />
            </svg>
            <h1>Statistics</h1>
        </div>
        <button class="close-btn" (click)="playerStatisticsSec = false">&times;</button>

        <div class="progress-section">
            <div class="progress-header">
                <strong>Progress:</strong>
                <strong>{{ vipProgress }}%</strong>
            </div>
            <div class="progress-bar">
                <div class="progress-fill" [style.width.%]="vipProgress"></div>
            </div>
            <div class="rank-indicators">
                <div class="rank-indicator">
                    <img src="../../../assets/imgs/vip/Ranks/{{currentRank}}.png" alt="Current Rank">
                    <span>{{ currentRank }}</span>
                </div>
                <div class="rank-indicator">
                    <img src="../../../assets/imgs/vip/Ranks/{{nextRankIcon}}.png" alt="Next Rank">
                    <span>{{ nextRankIcon }}</span>
                </div>
            </div>
        </div>

        <div class="statistics-section">
            <div class="statistics-cell">
                <span class="title">Number of Bets</span>
                <span class="value">{{ playerStatistics.numberOfBets }}</span>
            </div>
            <div class="statistics-cell">
                <span class="title">Number of Wins</span>
                <span class="value">{{ playerStatistics.numberOfWins }}</span>
            </div>
            <div class="statistics-cell">
                <span class="title">Number of Losses</span>
                <span class="value">{{ playerStatistics.numberOfLoss }}</span>
            </div>
            <div class="statistics-cell">
                <span class="title">Wagered</span>
                <span class="value"> {{playertype}}{{ playerStatistics.totalBetAmount }}</span>
            </div>

        </div>
    </div>
</div>




<div style="width: 100%;display:flex; ">
    <div class="sidenavlef bg_1 mobile_none" [ngClass]="{'sidenav': menuNames === false}">
        <div class="sidebar" [ngClass]="{'inactiveMenu': menuNames === false}">
            <div class="menu_btns">
                <button class="menuIconLines toggle-btn bg_2" [ngClass]="{'inactiveMenu': menuNames === false}"
                    (click)="openMenu()" aria-label="Open menu">
                    <!-- <span class="sr-only">Open menu</span> -->

                    <i [ngClass]="menuNames === false ? 'fa fa-angle-right' : 'fa fa-angle-left'" aria-hidden="true"
                        style='font-size: 24px;color: #fff;float: left;'></i>
                </button>
                <!-- <div class="btns_flx" *ngIf="menuNames"> 
                </div> -->
            </div>
            <!-- <span style="color: aqua;" class="fd comingSoon" *ngIf="errorMsg">{{errorMsg}}</span>
            <div class="search_box fd" (click)="proiderGamesAll()">
                <span class='fas fa-search'>
                </span>
                <span [ngClass]="{'inputwT' : menuNames == false}">{{'SEARCH' | translate}}</span>
            </div> -->

            <div class="pro_sc_T_div fd">
                <div class="sidebar" #menuContainer>

                    <div *ngFor="let item of menu; trackBy: trackByMenu" class="menu-item">

                        <!-- Parent -->
                        <div class="menu-parent" [class.left-menu-content]="item.expanded" #menuItem
                            (click)="toggleMenu(item,menuItem)" routerLinkActive="active"
                            [class.closepad]="menuNames === false">

                            <div class="df_menu" *ngIf="item.router" [routerLink]="item.router">
                                <img class="sidemeni_icon_div" src="../../../assets/sitelogos/{{item.name}}.svg" alt=""
                                    loading="lazy" decoding="async">
                                <span [class.closemenu]="menuNames === false">{{ item.name | translate}}</span>
                            </div>

                            <div class="df_menu" *ngIf="!item.router">
                                <img class="sidemeni_icon_div" src="../../../assets/sitelogos/{{item.name}}.svg" alt=""
                                    loading="lazy" decoding="async">

                                <span [class.closemenu]="menuNames === false">{{ item.name | translate}}</span>
                            </div>

                            <i *ngIf="item.children" class="fa" [class.closemenu]="menuNames === false"
                                [ngClass]="item.expanded ? 'fa fa-chevron-down' : 'fa fa-chevron-right'">
                            </i>
                        </div>
                        <!-- Children -->
                        <div class="submenu" *ngIf="item.expanded && item.name =='Hot Games' "
                            [class.closemenu]="menuNames === false" routerLinkActive="active">
                            <div *ngFor="let child of item.children;  trackBy: trackByMenu" class="submenu-item"
                                [routerLink]="child.router" (click)="navigatesection(child)">
                                <img [src]="child.media" loading="lazy" decoding="async" alt="" class="hotGms_img">
                                <span class="child_cs_hotGm"> {{ child.name }}</span>

                            </div>
                        </div>
                        <div class="submenu" *ngIf="item.expanded && item.name !='Hot Games'" routerLinkActive="active"
                            [class.closemenu]="menuNames === false">
                            <div *ngFor="let child of item.children;  trackBy: trackByMenu" class="submenu-item"
                                (click)="navigatesection(child)" [routerLink]="child.router">
                                <img [src]="child.media" loading="lazy" decoding="async" alt="">
                                <span class="child_cs">{{ child.displayName || child.name }}</span>
                                <!-- <span class="child_cs">{{ child.name.replace('GV','') }}</span> -->
                            </div>
                        </div>

                    </div>
                    <div class="menu-parent" *ngIf="playerLoggedIn" [class.closemenu]="menuNames === false"
                        (click)="onClickLogout()">
                        <div class="df_menu">
                            <img class="sidemeni_icon_div" src="../../../assets/sitelogos/LOGOUT.svg" alt=""
                                loading="lazy" decoding="async">
                            <span>{{ 'LOGOUT' | translate}}</span>
                        </div>
                    </div>

                </div>
            </div>

            <div class="pro_sc_T_div fd" *ngIf="false">
                <ul class="menu iconsUL">
                    <li (click)="getMenuFromPath('home')" routerLinkActive="active"
                        [class.active]="activeMenu === 'home'" [title]="'HOME' | translate">
                        <a routerLink="/home">
                            <div class="iconsList home_ic"></div>
                            <span>{{'HOME' | translate}}</span>
                        </a>
                        <span class='fas fa-caret-left arrowactive'></span>
                    </li>
                    <!-- <span style="border-bottom: 1px solid #ffffff;"></span> -->
                    <li *ngIf="providerList?.has('powerplay')" (click)="getMenuFromPath('sports')"
                        routerLinkActive="sports" [class.active]="activeMenu === 'sports'"
                        [title]="'SPORTS' | translate">
                        <a routerLink="/sports">
                            <div class="iconsList sports_ic"></div>
                            <span>{{'SPORTS' | translate}}</span>
                        </a>
                        <span class='fas fa-caret-left arrowactive'></span>
                    </li>
                    <li *ngIf="providerList?.has('ezugi') || providerList?.has('evolution') || providerList?.has('evolutiongv') || providerList?.has('ezugigv')"
                        (click)="getMenuFromPath('livecasino')" routerLinkActive="active"
                        [class.active]="activeMenu === 'livecasino'" [title]="'LIVE_CASINO' | translate">
                        <a routerLink="/livecasino">
                            <div class="iconsList livedealer_ic"></div>
                            <span>{{'LIVE_CASINO' | translate}}</span>
                        </a>
                        <span class='fas fa-caret-left arrowactive'></span>

                    </li>
                    <li *ngIf="providerList?.has('spribe')" (click)="getMenuFromPath('aviator')"
                        routerLinkActive="active" [class.active]="activeMenu === 'aviator'"
                        [title]="'AVIATOR' | translate">
                        <a routerLink="/aviator">
                            <div class="iconsList crash_ic"></div>
                            <span>{{'AVIATOR' | translate}}</span>
                        </a>
                        <span class='fas fa-caret-left arrowactive'></span>
                    </li>

                    <li *ngIf="providerList?.has('ballagames')" (click)="getMenuFromPath('ballagames')"
                        routerLinkActive="active" [class.active]="activeMenu === 'ballagames'"
                        [title]="'BALLA_GAMES' | translate">
                        <a routerLink="/ballagames">
                            <div class="iconsList Topgames_ic"></div>
                            <span>{{'BALLA_GAMES' | translate}}</span>
                        </a>
                        <span class='fas fa-caret-left arrowactive'></span>

                    </li>
                    <li (click)="getMenuFromPath('slots')" routerLinkActive="active"
                        [class.active]="activeMenu === 'slots'" [title]="'SLOTS' | translate">
                        <a routerLink="/slots">
                            <div class="iconsList slots_ic"></div>
                            <span>{{'SLOTS' | translate}}</span>
                        </a>
                        <span class='fas fa-caret-left arrowactive'></span>

                    </li>


                    <li *ngIf="providerList?.has('ezugi') || providerList?.has('evolution') || providerList?.has('evolutiongv') || providerList?.has('ezugigv')"
                        (click)="getMenuFromPath('roulette')" routerLinkActive="active"
                        [class.active]="activeMenu === 'roulette'" [title]="'ROULETTE' | translate">
                        <a routerLink="/roulette">
                            <div class="iconsList roulette_ic"></div>
                            <span>{{'ROULETTE'|translate}}</span>
                        </a>
                        <span class='fas fa-caret-left arrowactive'></span>

                    </li>

                    <li *ngIf="providerList?.has('ezugi') || providerList?.has('evolution') || providerList?.has('evolutiongv') || providerList?.has('ezugigv')"
                        (click)="getMenuFromPath('blackjack')" routerLinkActive="active"
                        [class.active]="activeMenu === 'blackjack'" [title]="'BLACKJACK' | translate">
                        <a routerLink="/blackjack">
                            <div class="iconsList blackjack_ic"></div>
                            <span>{{'BLACKJACK' | translate}}</span>
                        </a>
                        <span class='fas fa-caret-left arrowactive'></span>

                    </li>

                    <li *ngIf="providerList?.has('ezugi') || providerList?.has('evolution') || providerList?.has('evolutiongv') || providerList?.has('ezugigv')"
                        (click)="getMenuFromPath('baccarat')" routerLinkActive="active"
                        [class.active]="activeMenu === 'baccarat'" [title]="'BACCARAT' | translate">
                        <a routerLink="/baccarat">
                            <div class="iconsList baccarat_ic"></div>
                            <span>{{'BACCARAT' | translate}}</span>
                        </a>
                        <span class='fas fa-caret-left arrowactive'></span>

                    </li>

                    <li (click)="getMenuFromPath('lottery')" routerLinkActive="active"
                        [class.active]="activeMenu === 'lottery'" [title]="'LOTTERY' | translate">
                        <a routerLink="/lottery">
                            <div class="iconsList lottery_ic"></div>
                            <span>{{'LOTTERY' | translate}}</span>
                        </a>
                        <span class='fas fa-caret-left arrowactive'></span>

                    </li>

                    <li (click)="getMenuFromPath('promotions')" routerLinkActive="active"
                        [class.active]="activeMenu === 'promotions'" [title]="'PROMOTIONS' | translate">
                        <a routerLink="/promotions">
                            <div class="iconsList Promotions_ic"></div>
                            <span>{{'PROMOTIONS' | translate}}</span>
                        </a>
                        <span class='fas fa-caret-left arrowactive'></span>

                    </li>
                    <li (click)="getMenuFromPath('providers')" routerLinkActive="active"
                        [class.active]="activeMenu === 'providers'" [title]="'PROVIDERS' | translate">
                        <a routerLink="/providers">
                            <div class="iconsList provider_ic"></div>
                            <span>{{'PROVIDERS' | translate}}</span>
                        </a>
                        <span class='fas fa-caret-left arrowactive'></span>

                    </li>

                    <li (click)="getMenuFromPath('profile')" routerLinkActive="active"
                        [class.active]="activeMenu === 'profile'" [title]="'MY_ACCOUNT' | translate"
                        *ngIf="playerLoggedIn">
                        <a (click)="myprofile()">
                            <div class="iconsList myaccount_ic"></div>
                            <span>{{'MY_ACCOUNT' | translate}}</span>

                        </a>
                        <!-- <span class='fas fa-caret-left arrowactive'  ></span> -->

                        <span class="float_left" (click)="myprofile()">
                            <i *ngIf="openProfile" class='fas fa-angle-up'></i>
                            <i *ngIf="!openProfile" class='fas fa-angle-down'></i>
                        </span>

                    </li>
                    <div class="flex_cl" *ngIf="openProfile" #profileDropdown>

                        <li routerLinkActive="active" [title]="'PROFILE' | translate">
                            <a routerLink="/profile">
                                <div class="iconsList profile_ic"></div>
                                <span>{{'PROFILE' | translate}}</span>
                            </a>
                            <span class='fas fa-caret-left arrowactive'></span>


                        </li>

                        <li routerLinkActive="active" [title]="'MY_BALANCE' | translate">
                            <a routerLink="/mybalance">
                                <div class="iconsList My_balance_ic"></div>
                                <span>{{'MY_BALANCE' | translate}}</span>
                            </a>
                            <span class='fas fa-caret-left arrowactive'></span>

                        </li>

                        <li routerLinkActive="active" [title]="'TRANSACTION_HISTORY' | translate">
                            <a routerLink="/transactionhistory">
                                <div class="iconsList transactions_ic"></div>
                                <span>{{'TRANSACTION_HISTORY' | translate}}</span>
                            </a>
                            <span class='fas fa-caret-left arrowactive'></span>

                        </li>


                        <li routerLinkActive="active" [title]="'GAME_HISTORY' | translate">
                            <a routerLink="/casinogamehistory">
                                <div class="iconsList Recently_P_ic"></div>
                                <span>{{'GAME_HISTORY' | translate}}</span>
                            </a>
                            <span class='fas fa-caret-left arrowactive'></span>

                        </li>
                    </div>
                </ul>
            </div>

        </div>
    </div>
    <div class="rightsidenav bg_main" [ngClass]="{'rightside': menuNames === false}">
        <div class="container321">
            <header class="header bg_new " [ngClass]="{'headerWid': menuNames === false}">
                <section class="top-header container321">
                    <div class="fd df_jc_sb">
                        <div class="mobile_top mobile_menu">
                            <i class="fa fa-bars" (click)="toggleMobileMenu()"></i>
                        </div>
                        <div class="left-content df_alc">
                            <ul class="left-list ">
                                <li class="mobile_none">
                                    <a routerLink="/home" class="fd text-center" (click)="closeMenuNames('close')">
                                        <img class="main_logo darkMode" src="../../../assets/siteImg/Gambaji.svg"
                                            fetchpriority="high" alt="Gambaji" width="200" height="60">
                                    </a>
                                </li>
                                <li class="mobile_block">
                                    <a routerLink="/home" class="fd text-center" (click)="closeMenuNames('close')">
                                        <img class="main_logo darkMode" src="../../../assets/siteImg/Gambaji.svg"
                                            fetchpriority="high" alt="Gambaji" height="45" width="70">
                                    </a>
                                </li>
                            </ul>
                        </div>


                        <div class="right-content mobile_setting ">
                            <div class="center-content df_alc " *ngIf="playerLoggedIn">
                                <ul class="center-list df mr-2">
                                    <!-- <li *ngIf="gifLoader" class="loader-container">
                                        <img src="assets/siteImg/Loader.gif" alt="Loading..." class="loader-gif">
                                    </li> -->
                                    <li class="balance-sec" #balanceDropdown>
                                        <a (click)="toggleDropdown($event)">
                                            <!-- Bal: <span> {{playertype}}{{ balance }}</span> -->
                                            <span class="df align-items-center balance-txt"> {{playertype}} {{ balance
                                                }}

                                                <!-- <span class="m_l_5 doller_symbol-icon m_r_5">{{playertype}}</span> -->
                                                <!-- <i class="fas fa-coins" style="color: gold;"></i> -->
                                                <!-- <svg width="30" height="30" viewBox="0 0 16 44" fill="none"
                                                    xmlns="http://www.w3.org/2000/svg">
                                                    <circle cx="7.85714" cy="22.0002" r="7.85714" fill="#EAC74A" />
                                                    <path
                                                        d="M8.23072 25.9429H7.28787V25.066C5.76044 24.9246 4.9873 24.1326 4.9873 22.9351V22.8786H6.00558V23.0294C6.00558 23.7837 6.44872 24.1609 7.83472 24.1609C9.04158 24.1609 9.46587 23.8969 9.46587 23.3029C9.46587 22.756 9.1453 22.5486 8.34387 22.3977L6.79758 22.1431C5.73215 21.9546 4.97787 21.4643 4.97787 20.4271C4.97787 19.5786 5.62844 18.7206 7.28787 18.6074V17.74H8.23072V18.6169C9.70158 18.7771 10.3804 19.6351 10.3804 20.7477V20.8043H9.37158V20.6817C9.37158 19.9086 8.90958 19.522 7.59901 19.522C6.44872 19.522 5.99615 19.8049 5.99615 20.3706C5.99615 20.9174 6.31672 21.0966 7.06158 21.2569L8.59844 21.5209C9.86187 21.7471 10.4842 22.3223 10.4842 23.2463C10.4842 24.1326 9.81472 24.9623 8.23072 25.0754V25.9429Z"
                                                        fill="#1E1E1E" />
                                                </svg> -->
                                            </span>
                                            <span>
                                                <i [class.fa-angle-up]="profileHeader"
                                                    [class.fa-angle-down]="!profileHeader" class="fas"></i>
                                            </span>
                                        </a>
                                        <ul *ngIf="profileHeader" class="headerDrop">
                                            <!-- <li>{{ playerName }}</li> -->
                                            <li>Cash: {{playertype}} {{ cashuser }}</li>
                                            <li>Bonus: {{playertype}} {{ bounsuser }}</li>
                                            <!-- <li>Loyalty Points: {{ userCompoints }}</li> -->
                                        </ul>
                                    </li>
                                    <!-- <span class="mobile_none" (click)="openModal($event,'deposit')" *ngIf="hidedeposit">
                                        <li class="wallet_btn "> <img src="../../../assets/siteImg/Wallet_H.svg"
                                                alt="Deposit" width="30" height="30">{{'DEPOSIT' | translate}}</li>
                                    </span> -->
                                    <!-- <li (click)="openModal($event,'deposit')" class="wallet_btn mobile_block" *ngIf="hidedeposit"> <img
                                            src="../../../assets/siteImg/Wallet_H.svg" alt="wallet" width="45" height="40">
                                    </li> -->
                                </ul>
                            </div>

                            <ul class="right-list right_side_view mobile_none" *ngIf="!playerLoggedIn">
                                <li *ngIf="!playerLoggedIn" class="joinBG">
                                    <button (click)="showPopUp('REGISTER')" class="newLoginRegister">
                                        {{'JOIN_US' | translate}}
                                    </button>
                                </li>

                                <li *ngIf="!playerLoggedIn" class="login">
                                    <button (click)="showPopUp('LOGIN')" class="newLoginRegister">
                                        {{'LOGIN' | translate }}
                                    </button>
                                </li>


                                <!-- <li *ngIf="!playerLoggedIn" class="joinBG">
                                    <a (click)="showPopUp('WEBAUTH')" class="newLoginRegister">
                                        Login/Register
                                    </a>
                                </li> -->
                            </ul>
                            <ul *ngIf="playerLoggedIn" class="desktop_menu">
                                <li #avatarDropdown>
                                    <a (click)="toggleDropdownAvathar($event)">
                                        <span class="fas fa-user-circle" style="font-size: 34px;color: #fff;"></span>
                                    </a>
                                    <ul *ngIf="profileAvathar" class="headerDrop Po_Av">

                                        <li class="userProfile">
                                            <ul class="fd" style="border-bottom: 1px solid var(--border_clr);">
                                                <li (click)="openModal($event,'profile')" class="userProfile">
                                                    <span class="fas fa-user-circle"
                                                        style="font-size:34px;color:#fff"></span>
                                                    {{profile.login}}
                                                </li>
                                                <li class="flex_div">
                                                    <span>{{vipName1}}</span>
                                                    <span> <img src="../../assets/siteImg/leavelC/{{vipName}}.png"
                                                            loading="lazy" decoding="async" alt="" width="25"
                                                            height="25" alt="level.name"> {{vipName | translate}}</span>
                                                </li>
                                                <li class="userProfile">{{'CASH' | translate}} : {{playertype}} {{
                                                    cashuser }}</li>
                                                <li class="userProfile"> {{'BONUS' | translate}}: {{playertype}} {{
                                                    bounsuser }}</li>
                                                <li class="userProfile"> {{'BONUS_WAGER' | translate}}: {{playertype}}
                                                    {{
                                                    bounsuserWager }}</li>
                                                <li class="userProfile"> {{'Locked_Bonus' | translate}}: {{playertype}}
                                                    {{
                                                    lockedBonus }}</li>
                                            </ul>
                                        </li>

                                        <li (click)="openModal($event,'deposit')" *ngIf="hidecashout">
                                            <!-- <i class="fas fa-wallet" style="font-size: 15px; margin-right: 3px;"></i> -->
                                            <img src="../../../assets/siteImg/profiledrop_icon/icon-deposit.png"
                                                class="mar_right_10 sidemeni_icon_div" loading="lazy" decoding="async"
                                                alt="">
                                            {{'DEPOSIT' | translate}}
                                        </li>
                                        <li (click)="openModal($event,'cashout')" *ngIf="hidecashout">
                                            <!-- <i class="fas fa-wallet" style="font-size: 15px; margin-right: 3px;"></i> -->
                                            <img src="../../../assets/siteImg/profiledrop_icon/icon-withdrawal.png"
                                                class="mar_right_10 sidemeni_icon_div" loading="lazy" decoding="async"
                                                alt="">

                                            {{'CASHOUT' | translate}}
                                        </li>

                                        <li (click)="openModal($event,'transactionhistory')">
                                            <!-- <li (click)="toggleDropdownAvathar($event)" routerLink="/transactionhistory"> -->
                                            <!-- <i class='fas fa-exchange-alt' style='font-size:15px; margin-right: 3px;'></i> -->
                                            <img src="../../../assets/siteImg/profiledrop_icon/icon-daily-login.png"
                                                class="mar_right_10 sidemeni_icon_div" loading="lazy" decoding="async"
                                                alt="">
                                            {{'TRANSACTION_HISTORY' | translate}}
                                        </li>
                                        <li (click)="openModal($event,'casinogamehistory')">
                                            <!-- <li (click)="toggleDropdownAvathar($event)" routerLink="/casinogamehistory"> -->
                                            <!-- <i class='fas fa-history' style='font-size:15px;margin-right: 3px;'></i> -->
                                            <img src="../../../assets/siteImg/profiledrop_icon/icon-records.png"
                                                class="mar_right_10 sidemeni_icon_div" loading="lazy" decoding="async"
                                                alt="">

                                            {{'GAME_HISTORY' | translate}}
                                        </li>

                                        <!-- <li (click)="toggleDropdownAvathar($event)" routerLink="/exchange-currency">
                                            <i class='fas fa-exchange-alt'
                                                style='font-size:15px;margin-right: 3px;'></i>
                                            Exchange
                                        </li>
 
                                        <li (click)="openLiveSupport()"> 
                                            <i class="fas fa-headset" style="font-size: 15px; margin-right: 3px;"></i>
                                            Live Support
                                        </li> -->

                                        <li (click)="openModal($event,'profile')">
                                            <!-- <li (  click)="toggleDropdownAvathar($event)" routerLink="/profile"> -->
                                            <img src="../../../assets/siteImg/profiledrop_icon/icon-profile.png"
                                                class="mar_right_10 sidemeni_icon_div" loading="lazy" decoding="async"
                                                alt="">
                                            <!-- <i class='fas fa-user-alt' style='font-size: 15px;margin-right: 3px;'></i> -->
                                            {{'PROFILE' | translate}}
                                        </li>

                                        <li (click)="onClickLogout()">
                                            <!-- <li (click)="showLogOutPopup()">  -->
                                            <img src="../../../assets/siteImg/profiledrop_icon/icon-logout.png"
                                                class="mar_right_10 sidemeni_icon_div" loading="lazy" decoding="async"
                                                alt="">
                                            <!-- <span class='fas fa-sign-out-alt' style='font-size:15px;margin-right: 3px;color: #f00;'></span> -->
                                            {{'LOGOUT' | translate}}
                                        </li>
                                    </ul>
                                </li>
                            </ul>
                            <!-- <div>
                                <a href="https://gambaji.com/download/mobile/Gambaji.apk" download>
                                    <img src="https://img.d4040p.com/dp/h5/assets/images/icon-set/index-theme-icon/header-appdownload-icon.svg?v=1776751585638"
                                        alt="">
                                </a>
                            </div> -->

                            <!-- <div class="download-box" *ngIf="isAndroid" (click)="downloadApp()">
                                <div class="icon-wrapper">
                                    <i class="fa fa-download download-icon"></i>
                                </div>
                                <div class="app-text">
                                    <strong>App</strong>
                                </div>
                            </div> -->
                            <div>
                                <div class="lang-trigger" (click)="toggleDropdown_lan()">
                                    <img [src]="'assets/siteImg/language_icon/' + selectedLang + '.svg'" alt="lang"
                                        loading="lazy" decoding="async" />
                                </div>
                                <!-- BACKDROP -->
                                <div class="lang-overlay" *ngIf="openClose" (click)="toggleDropdown_lan()"></div>

                                <!-- MODAL -->
                                <div class="lang-popup" *ngIf="openClose">

                                    <!-- HEADER -->
                                    <div class="popup-header">
                                        <span class="lang_dis_flex">{{'Language' | translate}}</span>
                                        <i class="fas fa-times" (click)="toggleDropdown_lan()"></i>
                                    </div>

                                    <!-- BODY -->
                                    <div class="popup-body">

                                        <!-- Currency -->
                                        <div class="currency">
                                            <span class="flag"></span>
                                            <span>৳ BDT</span>
                                        </div>

                                        <!-- Language Buttons -->
                                        <div class="lang-buttons">
                                            <button *ngFor="let lang of languages; trackBy: trackByLang"
                                                [class.active]="tempLang === lang.code"
                                                (click)="selectTempLang(lang.code)">
                                                {{ lang.label }}
                                            </button>
                                        </div>

                                    </div>

                                    <!-- FOOTER -->
                                    <!-- <div class="popup-footer">
                                        <button class="confirm-btn" (click)="confirmLang()">Confirm</button>
                                    </div> -->

                                </div>
                            </div>

                        </div>
                    </div>
                </section>
            </header>


            <!-- <div *ngIf="statusMessage" [ngStyle]="{'margin-top': !playerLoggedIn ? '90px' : '0px'}">
                <app-carousel></app-carousel>
            </div> -->
            <div class="black_cover" *ngIf="logoutPopup" (click)="hideLogOutPopup()">
            </div>
            <div class="logoutpopup" *ngIf="logoutPopup">
                <i class='fas fa-times' style='font-size:24px;color: #fff;' (click)="hideLogOutPopup()"></i>
                <div class="flexContent">
                    <i class='fas fa-user-alt frist'></i>
                    <i class='fas fa-user-alt second'></i>
                </div>
                <h3>{{'LOGOUT_CONFIRM' | translate}}</h3>
                <div class="flexContent1">
                    <button (click)="hideLogOutPopup()">{{'NO' | translate}}</button>
                    <button (click)="onClickLogout()">{{'YES' | translate}}</button>
                </div>

            </div>

            <div class="fd" [ngStyle]="{'margin-top': playerLoggedIn ? '60px' : '60px'}">
                <!-- <div class="  fd" [ngStyle]="{'margin-top': playerLoggedIn ? '90px' : '0px'}"> -->
                <router-outlet></router-outlet>
                <!-- <div *ngIf="allproiderGames" >
                    <a class="btn-whats pulse" href="https://wa.me/16728246224" target="_blank">
                      
                      <i class='fab fa-whatsapp'></i>
                    </a>
                  </div> -->
            </div>

            <!-- <div class="fd" *ngIf="router.url !== '/providers' && router.url !== '/home'">
                <div class="container321 fd p_0">
                    <app-footer-provider></app-footer-provider>
                </div>
            </div> -->
            <div class="fd" *ngIf="allproiderGames">
                <div class="black_cover" *ngIf="allproiderGames" (click)="proiderGamesClose()"></div>
                <div class="fd container321 gamesPopup bg_7" *ngIf="allproiderGames"
                    style="z-index: 100000 !important;">
                    <div (click)="proiderGamesClose()" class="closeComp"><i class='fas fa-times'
                            style='font-size:24px'></i></div>
                    <app-all-gameprovider (gameLaunched)="proiderGamesClose()" class="fd"></app-all-gameprovider>
                </div>
            </div>
        </div>
        <div class="fd bg_8">
            <div class="container321">
                <app-footer></app-footer>
            </div>
        </div>
    </div>
    <!-- ANDROID DOWNLOAD BANNER -->

    <div class="app-download-banner" *ngIf="showDownloadBanner && !playerLoggedIn">

        <button class="close-download-banner" (click)="closeDownloadBanner()">
            ✕
        </button>

        <div class="download-left">

            <img src="../../../assets/siteImg/Gambaji.svg" class="download-app-logo" loading="lazy" decoding="async"
                alt="">

            <div class="download-text">
                <h4>Gambaji Web App</h4>
                <p>⭐⭐⭐⭐⭐</p>
            </div>

        </div>

        <button class="download-now-btn" (click)="downloadApp()">
            Download
        </button>

    </div>

    <div class="mobile_block" *ngIf="statusMessage && playerLoggedIn && MobilwBottomMenu">
        <div class="button-container">
            <!-- <div routerLink="/home" class="dmg">
                <div class="spin">◌</div>
            </div> -->
            <button *ngFor="let link of links; let i = index" class="mobile-button" [class.active]="link.active"
                (click)="onLinkClickmenu($event,link)">
                <!-- <i *ngIf="link.name !== 'AVIATOR'" class='fas ' [ngClass]="link.icon" style='font-size:18px'></i> -->
                <img src="{{link.iconimg}}" alt="Aviator" width="26" height="26" style="margin: auto;" loading="lazy"
                    decoding="async"> {{ link.name |
                translate}}</button>
        </div>
    </div>

    <!-- <div class="mobile_block" *ngIf="statusMessage && !playerLoggedIn">
        <div class="button-container" style="justify-content: center;">
            <ul class="right-list " *ngIf="!playerLoggedIn">
                <li *ngIf="!playerLoggedIn" class="joinBG">
                    <button (click)="showPopUp('REGISTER')" class="newLoginRegister">
                        {{'JOIN_US' | translate}}
                    </button>
                </li>

                <li *ngIf="!playerLoggedIn" class="login">
                    <button (click)="showPopUp('LOGIN')" class="newLoginRegister">
                        {{'LOGIN' | translate }}
                    </button>
                </li>

            </ul>
        </div>
    </div> -->


    <div class="mobile_block mobile-bottom-auth" *ngIf="statusMessage && !playerLoggedIn">
        <div class="mobile-auth-wrapper">
            <ul class="mobile-auth-list" *ngIf="!playerLoggedIn">
                <li class="mobile-auth-lang">
                    <div class="lang-circle"></div>

                    <div class="lang-text" (click)="toggleDropdown_lan()">
                        <span>BDT</span>
                        <small>{{selectedLang == 'BN'? 'বাংলা' : 'English'}}</small>
                    </div>
                </li>

                <li class="mobile-auth-signup">
                    <button (click)="showPopUp('REGISTER')" class="mobile-auth-btn">
                        {{'JOIN_US' | translate}}
                    </button>
                </li>

                <li class="mobile-auth-login">
                    <button (click)="showPopUp('LOGIN')" class="mobile-auth-btn">
                        {{'LOGIN' | translate }}
                    </button>
                </li>

            </ul>
        </div>
    </div>



</div>

<!-- ====================================== Avtar Popup - Start ====================================== -->
<div class="black_cover" *ngIf="showAvtars"></div>
<div class="popup_1 pop_sm" *ngIf="showAvtars">
    <span class="casino_pupop" (click)="onChangeAvtar($event)">
        <i class='fas fa-times'></i>
    </span>
    <div class="avtar-container">
        <div *ngFor="let avtar of avatarList">
            <img src="data:image/png;base64,{{avtar.imageData}}" loading="lazy" decoding="async" alt=""
                (click)="selectAvtar(avtar)" />
        </div>
    </div>
    <div class="avtar-preview-container">
        <div>
            <span *ngIf="previewAvtar"> Preview:</span>
            <span *ngIf="!previewAvtar">please select above to set</span>
            <img [src]="previewAvtar" class="previewAvtarImage" alt="Avatar" loading="lazy" decoding="async" />
        </div>

        <button type="button" class="btn_1" [disabled]="!previewAvtar" (click)="setAvtar()">
            Set Avatar
        </button>
    </div>
</div>

<!-- ====================================== Avtar Popup - End ====================================== -->

<div class="black_cover" *ngIf="casinogamessuccessPop" (click)="casinogamessuccessPopClose()"></div>
<div class="popup_1 pop_sm" *ngIf="casinogamessuccessPop">
    <span class="casino_pupop" (click)="casinogamessuccessPopClose()"> <i class='fas fa-times'></i></span>
    <div class="soon font_16">
        {{casinomessage}} <br> <br>
        <button class="btn_comSoon" (click)="casinogamessuccessPopClose()"> OK</button>
    </div>
</div>

<div class="black_cover" *ngIf="sessionExpiresuccessPop"></div>
<div class="modern-popup-top" *ngIf="sessionExpiresuccessPop">
    <div class="popup-content">
        <div class="df">
            <div class="icon-container">
                <svg class="session-icon" viewBox="0 0 24 24">
                    <path fill="currentColor"
                        d="M11,15H13V17H11V15M11,7H13V13H11V7M12,2C6.47,2 2,6.5 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2M12,20A8,8 0 0,1 4,12A8,8 0 0,1 12,4A8,8 0 0,1 20,12A8,8 0 0,1 12,20Z" />
                </svg>
            </div>

            <div class="text-content">
                <h3 class="popup-title">{{'Session_Alert' | translate}}</h3>
                <p class="popup-message">{{'SESSION_HAS_EXPIRED' | translate}}</p>
            </div>

            <button class="modern-close-btn" (click)="sessionExpiresuccessPopClose()">
                <svg viewBox="0 0 24 24">
                    <path fill="currentColor"
                        d="M19,6.41L17.59,5L12,10.59L6.41,5L5,6.41L10.59,12L5,17.59L6.41,19L12,13.41L17.59,19L19,17.59L13.41,12L19,6.41Z" />
                </svg>
            </button>
        </div>
        <div class="popup-actions">
            <button class="modern-action-btn" (click)="sessionExpiresuccessPopClose()">
                Got It
            </button>
        </div>
    </div>

</div>



<!-- ##################### Deposit message popup ################################# -->





<!-- <div class="fullpage mobile_block" [class.show]="menushow"> -->
<!-- <div class="mobile_side_sub">
        <span>{{errorMsg}}</span>

        <div (click)="closeMenu();proiderGamesAll() " class="search_box bb_line">
            <span class='fas fa-search'>
            </span>
            <input type="text" [placeholder]="'SEARCH' | translate" name="search" id="search_ID"
                [ngClass]="{'inputwT' : menuNames == false}">
        </div>
        <div class="mB_Tb m_b_50">
            <ul class="iconsUL">
                <li (click)="closeMenu()" routerLinkActive="active">
                    <a routerLink="/home">
                        <div class="iconsList home_ic"></div>
                        <span>{{'HOME' | translate}}</span>
                    </a>
                    <span class='fas fa-caret-left arrowactive'></span>

                </li>

                <li *ngIf="providerList?.has('powerplay') " (click)="closeMenu()" routerLinkActive="active">
                    <a routerLink="/sports">
                        <div class="iconsList sports_ic"></div>
                        <span>{{'SPORTS' | translate}}</span>
                    </a>
                    <span class='fas fa-caret-left arrowactive'></span>
                </li>

                <li *ngIf="providerList?.has('ezugi') || providerList?.has('evolution') || providerList?.has('evolutiongv') || providerList?.has('ezugigv')"
                    (click)="closeMenu()" routerLinkActive="active">
                    <a routerLink="/livecasino">
                        <div class="iconsList livedealer_ic"></div>
                        <span>{{'LIVE_CASINO' | translate}}</span>
                    </a>
                    <span class='fas fa-caret-left arrowactive'></span>
                </li>

                <li *ngIf="providerList?.has('spribe')" (click)="closeMenu()" routerLinkActive="active">
                    <a routerLink="/aviator">
                        <div class="iconsList crash_ic"></div>
                        <span>{{'AVIATOR' | translate}}</span>
                    </a>
                    <span class='fas fa-caret-left arrowactive'></span>
                </li>

                <li *ngIf="providerList?.has('ballagames')" (click)="closeMenu()" routerLinkActive="active">
                    <a routerLink="/ballagames">
                        <div class="iconsList Topgames_ic"></div>
                        <span>{{'BALLA_GAMES' | translate}}</span>
                    </a>
                    <span class='fas fa-caret-left arrowactive'></span>
                </li>
                <li (click)="closeMenu()" routerLinkActive="active">
                    <a routerLink="/slots">
                        <div class="iconsList slots_ic"></div>
                        <span>{{'SLOTS' | translate}}</span>
                    </a>
                    <span class='fas fa-caret-left arrowactive'></span>
                </li>

                <li *ngIf="providerList?.has('ezugi') || providerList?.has('evolution') || providerList?.has('evolutiongv') || providerList?.has('ezugigv')"
                    (click)="closeMenu()" routerLinkActive="active">
                    <a routerLink="/roulette">
                        <div class="iconsList roulette_ic"></div>
                        <span>{{'ROULETTE'|translate}}</span>
                    </a>
                    <span class='fas fa-caret-left arrowactive'></span>
                </li>

                <li *ngIf="providerList?.has('ezugi') || providerList?.has('evolution') || providerList?.has('evolutiongv') || providerList?.has('ezugigv')"
                    (click)="closeMenu()" routerLinkActive="active">
                    <a routerLink="/blackjack">
                        <div class="iconsList blackjack_ic"></div>
                        <span>{{'BLACKJACK' | translate}}</span>
                    </a>
                    <span class='fas fa-caret-left arrowactive'></span>
                </li>

                <li *ngIf="providerList?.has('ezugi') || providerList?.has('evolution') || providerList?.has('evolutiongv') || providerList?.has('ezugigv')"
                    (click)="closeMenu()" routerLinkActive="active">
                    <a routerLink="/baccarat">
                        <div class="iconsList baccarat_ic"></div>
                        <span>{{'BACCARAT' | translate}}</span>
                    </a>
                    <span class='fas fa-caret-left arrowactive'></span>
                </li>
                <li (click)="closeMenu()" routerLinkActive="active">
                    <a routerLink="/promotions">
                        <div class="iconsList Promotions_ic"></div>
                        <span>{{'PROMOTIONS'|translate}}</span>
                    </a>
                    <span class='fas fa-caret-left arrowactive'></span>
                </li>

                <li (click)="closeMenu()" routerLinkActive="active">
                    <a routerLink="/providers">
                        <div class="iconsList provider_ic"></div>
                        <span>{{'PROVIDERS' | translate}}</span>
                    </a>
                    <span class='fas fa-caret-left arrowactive'></span>

                </li>

                <li routerLinkActive="active" *ngIf="playerLoggedIn">
                    <a (click)="myprofile()">
                        <div class="iconsList myaccount_ic"></div>
                        <span>{{'MY_ACCOUNT' | translate}}</span>

                    </a>
                    <span class="float_left" (click)="myprofile()">
                        <i *ngIf="openProfile" class='fas fa-angle-up'></i>
                        <i *ngIf="!openProfile" class='fas fa-angle-down'></i>
                    </span>

                </li>





                <div class="flex_cl" *ngIf="openProfile">

                    <li (click)="closeMenu()" routerLinkActive="active">
                        <a routerLink="/profile">
                            <div class="iconsList profile_ic"></div>
                            <span>{{'PROFILE' | translate}}</span>

                        </a>
                        <span class='fas fa-caret-left arrowactive'></span>
                    </li>
                    <li (click)="closeMenu()" routerLinkActive="active">
                        <a routerLink="/mybalance">
                            <div class="iconsList My_balance_ic"></div>
                            <span>{{'MY_BALANCE' | translate}}</span>
                        </a>
                        <span class='fas fa-caret-left arrowactive'></span>
                    </li>

                    <li (click)="closeMenu()" routerLinkActive="active">
                        <a routerLink="/transactionhistory">
                            <i class='fas fa-exchange-alt' style='font-size:15px; margin-right: 3px;'></i>
                            <span>{{'TRANSACTION_HISTORY' | translate}}</span>
                        </a>
                        <span class='fas fa-caret-left arrowactive'></span>
                    </li>

                    <li (click)="closeMenu()" routerLinkActive="active">
                        <a routerLink="/exchange-currency">
                            <div class="iconsList exchange_ic"></div>
                            <span>Trade</span>
                        </a>
                        <span class='fas fa-caret-left arrowactive'></span>
                    </li>

                    <li (click)="closeMenu()" routerLinkActive="active">
                        <a routerLink="/casinogamehistory">
                            <i class='fas fa-history' style='font-size:15px;margin-right: 3px;'></i>
                            <span>{{'GAME_HISTORY' | translate}}</span>
                        </a>
                        <span class='fas fa-caret-left arrowactive'></span>
                    </li>

                </div>
                <li (click)="closeMenu()" *ngIf="playerLoggedIn">
                    <a (click)="showLogOutPopup()">
                        <i class='fas fa-sign-out-alt' style='font-size:20px;margin-right: 8px;color: #f00;'></i>
                        <span>{{'LOGOUT' | translate}}</span>

                    </a>
                    <span class='fas fa-caret-left arrowactive'></span>
                </li>

            </ul>

        </div>

    </div> -->

<!-- MOBILE MENU -->
<div class="mobile_menu" [class.show]="menushow">

    <!-- TOP BAR -->
    <!-- <div class="mobile_top">
        <i class="fa fa-bars" (click)="toggleMobileMenu()"></i>
        <span>MENU</span>
    </div> -->

    <!-- OVERLAY -->
    <div class="mobile_overlay" *ngIf="mobileMenuOpen" (click)="toggleMobileMenu()"></div>

    <!-- SIDE DRAWER -->
    <div class="mobile_drawer" [class.open]="mobileMenuOpen">
        <!-- CATEGORY LIST -->
        <div *ngFor="let item of menu;  trackBy: trackByMenu">
            <!-- PARENT -->
            <div class="mobile_parent" (click)="selectMobileMenu(item)">
                <!-- <i [class]="item.icon"></i> -->
                <div class="df_menu" *ngIf="item.router" [routerLink]="item.router">
                    <img class="sidemeni_icon_div" src="../../../assets/sitelogos/{{item.name}}.svg" alt=""
                        loading="lazy" decoding="async">
                    <span>{{ item.name | translate}}</span>
                </div>

                <div class="df_menu" *ngIf="!item.router">
                    <img class="sidemeni_icon_div" src="../../../assets/sitelogos/{{item.name}}.svg" alt=""
                        loading="lazy" decoding="async">

                    <span [class.closemenu]="menuNames === false">{{ item.name | translate}}</span>
                </div>

                <i *ngIf="item.children" class="fa"
                    [ngClass]="selectedMobile === item ? 'fa-angle-down' : 'fa-angle-right'">
                </i>
            </div>

            <!-- CHILDREN -->
            <div class="mobile_children" *ngIf="selectedMobile === item">
                <div *ngFor="let child of item.children" class="mobile_child" [routerLink]="child.router"
                    (click)="navigatesectionMobile(child)">
                    <img [src]="child.media" loading="lazy" decoding="async" alt="">
                    <span *ngIf="item.name !='Hot Games'" class="child_cs">{{ child.displayName || child.name }}</span>
                    <!-- <span *ngIf="item.name !='Hot Games'" class="child_cs">{{child.name.replace('GV','')}}</span> -->
                    <span *ngIf="item.name =='Hot Games'">{{child.name}}</span>
                </div>
            </div>
        </div>

        <div class="mobile_parent" *ngIf="playerLoggedIn" [class.closemenu]="menuNames === false"
            (click)="onClickLogout()">
            <div class="df_menu">
                <img class="sidemeni_icon_div" src="../../../assets/sitelogos/LOGOUT.svg" alt="" loading="lazy"
                    decoding="async">
                <span>{{ 'LOGOUT' | translate}}</span>
            </div>
        </div>

    </div>

</div>

<!-- EXISTING HEADER -->

<p style="color:red">Modal: {{ modalType }}</p>

<div class="modal-overlay" *ngIf="modalType" (click)="closeModal()">
    <div class="modal-container" (click)="$event.stopPropagation()">

        <div class="modal-header">
            <span class="text-center">{{ popnametranslate | translate}}</span>
            <button class="closeModal" (click)="closeModal()">✕</button>
        </div>

        <ng-container [ngSwitch]="modalType">
            <app-deposit *ngSwitchCase="'deposit'"></app-deposit>
            <app-withdraw *ngSwitchCase="'cashout'"></app-withdraw>
            <app-profile *ngSwitchCase="'profile'"></app-profile>
            <app-transaction-history *ngSwitchCase="'transactionhistory'"></app-transaction-history>
            <app-casino-history *ngSwitchCase="'casinogamehistory'"></app-casino-history>
            <app-myaccount *ngSwitchCase="'myaccount'"></app-myaccount>
        </ng-container>

    </div>
</div>

<!-- </div> -->